// Module
var code = `<template>
    <div class="comp-theme-toggle">
        <input type="checkbox" id="darkmode-toggle" checked.bind="isChecked" change.delegate="toggleTheme()" />
        <label for="darkmode-toggle"></label>
</template>`;
// Exports
export default code;